var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconV2Applieddate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.70361C0 2.15133 0.447716 1.70361 1 1.70361H15C15.5523 1.70361 16 2.15133 16 2.70361V14.9999C16 15.5522 15.5523 15.9999 15 15.9999H1C0.447716 15.9999 0 15.5522 0 14.9999V2.70361ZM1 2.37028C0.815906 2.37028 0.666668 2.51952 0.666668 2.70361V14.9999C0.666668 15.184 0.815906 15.3333 1 15.3333H15C15.1841 15.3333 15.3334 15.184 15.3334 14.9999V2.70361C15.3334 2.51952 15.1841 2.37028 15 2.37028H1Z",
    fill: "#001225"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.569 6.76414C12.6992 6.89431 12.6992 7.10537 12.569 7.23554L6.73334 13.0713L4.09763 10.4355C3.96746 10.3054 3.96746 10.0943 4.09763 9.96414C4.22781 9.83396 4.43886 9.83396 4.56904 9.96414L6.73334 12.1284L12.0976 6.76414C12.2278 6.63396 12.4389 6.63396 12.569 6.76414Z",
    fill: "#001225"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.33317H0V4.6665H16V5.33317Z",
    fill: "#001225"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99992 1.45705e-08C5.18401 6.52343e-09 5.33325 0.149239 5.33325 0.333334L5.33325 3.00001C5.33325 3.1841 5.18401 3.33334 4.99992 3.33334C4.81582 3.33334 4.66658 3.1841 4.66658 3.00001L4.66658 0.333334C4.66658 0.149239 4.81582 2.26176e-08 4.99992 1.45705e-08Z",
    fill: "#001225"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 3L10.6667 0.333334C10.6667 0.149239 10.8159 -2.66793e-08 11 -1.71871e-08C11.1841 -7.69494e-09 11.3334 0.149239 11.3334 0.333334L11.3334 3.00001C11.3334 3.1841 11.1841 3.33334 11 3.33334C10.8159 3.33334 10.6667 3.1841 10.6667 3Z",
    fill: "#001225"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconV2Applieddate);
export default __webpack_public_path__ + "static/media/icon-v2_applied date.4fefc135daedf75804408ef7bf537efe.svg";
export { ForwardRef as ReactComponent };